export function downloadFileDirectly(url: string, fileName = ''): void {
    const link = document.createElement('a');
    (window as any).removeAllListeners('beforeunload'); //removeAllListeners jest w zone.js
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
